import React from 'react';
import { unescapeHtml } from '../../../components/common/Common';
import cancelIcon from "../../../img/icon/icon-cancel.svg";
import "../../../css/style.css";

const FlyCheckDetail = ({varShowSubChecks,setShowSubChecks,varStudysList,varChecksInfo,onChangeInputHandler,onUpdateChecksHandler}) => {
  return (
    <div className="layer-pop" style={varShowSubChecks?{display:"block",width:"900px",height:"500px",border:"solid 1px #eee",borderRadius:"10px"}:{display:"none"}}>
      <div className="layer-hd">
        <div className="tit">플라이 진도표</div>
        <div className="close-layer" onClick={()=>setShowSubChecks(false)}><img src={cancelIcon} alt=""/></div>
      </div>
      <div className="vh-content-body ct-mdt-wrap">
        <div className="mdt-con">
          <div className="center-wrap">
            <div className="main-box" >
              <table cellPadding="5" cellSpacing="0" border="1" className="write">
                <colgroup><col width="30%"/><col width="70%"/></colgroup>
                <thead></thead>
                <tbody>
                  <tr>
                    <th>단계</th>
                    <td>
                      <select className="w_s_input" style={{width:"150px"}} name="vts_idx" value={varChecksInfo.vts_idx} onChange={(e)=>onChangeInputHandler(e)}>
                        {varStudysList.map((item,i) => (
                          <option key={'vts_'+i} value={item}>{item} 단계</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>챕터(1~4)</th>
                    <td>
                      <select className="w_s_input" style={{width:"150px"}} name="vtc_chapter" value={varChecksInfo.vtc_chapter} onChange={(e)=>onChangeInputHandler(e)}>
                        <option value={0}>챕터선택</option>
                        <option value={1}>1</option>
                        <option value={2}>2</option>
                        <option value={3}>3</option>
                        <option value={4}>4</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>직접목적</th>
                    <td><input type="text" className="w_s_input" name="vtc_purpose_direct" value={varChecksInfo.vtc_purpose_direct||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
                  </tr>
                  <tr>
                    <th>간접목적</th>
                    <td><input type="text" className="w_s_input" name="vtc_purpose_indirect" value={unescapeHtml(varChecksInfo.vtc_purpose_indirect)||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
                  </tr>
                  <tr>
                    <th>다음수업</th>
                    <td><input type="text" className="w_s_input" name="vtc_next_class" value={unescapeHtml(varChecksInfo.vtc_next_class)||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="btn-center" style={{marginBottom:"20px"}}>
              <button onClick={(e)=>onUpdateChecksHandler(e)} style={{width:"90px"}} className="btn">저장</button>
              <button onClick={()=>setShowSubChecks(false)} style={{width:"90px"}} className="btn line">닫기</button>
            </div>
          </div>
        </div>
      </div>
    </div>	
  )
}
export default FlyCheckDetail;